import { motion } from "framer-motion";
import { Play, Clock3 } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

// Jab 15-sec personal video ready ho — URL yahan daal do, section automatically video play karne lagega
const DIRECTOR_VIDEO_URL = "";

export const DirectorsDesk = () => (
  <section data-testid="directors-desk" className="bg-white py-[100px] md:py-[120px] border-t border-[#E5E7EB]">
    <div className="max-w-[1320px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
      {/* Video frame */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, ease }}
        className="lg:col-span-7"
      >
        <div className="relative rounded-[22px] overflow-hidden border border-[#E5E7EB] shadow-[0_30px_70px_-25px_rgba(15,42,67,0.35)] group">
          {DIRECTOR_VIDEO_URL ? (
            <video src={DIRECTOR_VIDEO_URL} controls playsInline className="w-full aspect-video object-cover" data-testid="directors-video" />
          ) : (
            <>
              <img
                src="/assets/about-main.jpg"
                alt="Akhilesh Kumar Suman — Director's Desk"
                loading="lazy"
                className="w-full aspect-video object-cover object-[center_20%] group-hover:scale-[1.02] transition-transform duration-300"
              />
              <span className="absolute inset-0 bg-[#0F2A43]/35" />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="w-16 h-16 rounded-full bg-white/15 backdrop-blur border border-white/40 flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-300">
                  <Play size={22} fill="currentColor" />
                </span>
              </span>
              <span className="absolute top-4 left-4 inline-flex items-center gap-2 bg-white/90 backdrop-blur font-mono text-[8px] font-bold tracking-[0.25em] uppercase text-[#0F2A43] px-3.5 py-1.5 rounded-full">
                <Clock3 size={10} /> 15 Sec — Coming Soon
              </span>
            </>
          )}
        </div>
      </motion.div>

      {/* Copy */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay: 0.1, ease }}
        className="lg:col-span-5"
      >
        <p className="font-mono text-[12px] tracking-[0.35em] uppercase text-[#4F6D8A]">Director's Desk</p>
        <h2 className="mt-4 font-serif text-[34px] md:text-[44px] leading-[1.08] text-[#111827]">A Personal Note</h2>
        <span className="mt-5 block w-14 h-[2px] bg-[#4F6D8A]" />
        <p className="mt-6 font-serif italic text-xl md:text-2xl text-[#374151] leading-relaxed">
          "Hi, I'm Akhilesh Kumar Suman. Let's create your next cinematic story."
        </p>
        <p className="mt-6 text-[#6B7280] leading-relaxed text-sm">
          Har project ke peeche ek phone call hota hai — seeds, scale, aur story. Video jald aa raha hai; tab tak WhatsApp ya call par baat karte hain.
        </p>
        <p className="mt-6 font-[Caveat] text-3xl text-[#111827]/70 -rotate-2 select-none">Akhilesh Kumar Suman</p>
      </motion.div>
    </div>
  </section>
);
